import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import auth from '@udacity/ureact-hoth';
import _isArray from 'lodash/isArray';
import _map from 'lodash/map';

import { useFetchCertificationsQuery } from 'app/apis/reviews';
import { MentorTypeCard } from 'app/common/components/dashboard-switcher/mentor-type-card';
import { LoadingPage } from 'app/common/views/loading-page';
import dashboardHelper from 'app/helpers/dashboard-helper';
import { useGetMentorQuery } from 'app/mentor/queries/enhanced';

import styles from './dashboard-switcher.module.scss';

export const DashboardSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const uid = auth.getCurrentUserId() || '';
  const { data: mentorData, isLoading: isMentorLoading } = useGetMentorQuery({ uid }, { skip: !uid });
  const { data: certifications, isLoading: isCertificationsLoading } = useFetchCertificationsQuery();
  const mentor = mentorData?.mentor;
  const services = mentor?.services ?? {};
  const isLoading = isMentorLoading || isCertificationsLoading;

  useEffect(() => {
    if (isLoading) {
      return;
    }
    const enabledServices = dashboardHelper.getEnabledServices({
      ...services,
      opportunities: Boolean(mentor?.uid),
    });
    const isCertified = (certifications ?? []).some((certification) => certification.status === 'certified');
    const redirectTo = dashboardHelper.selectServiceForRedirection(enabledServices, isCertified);

    if (!_isArray(redirectTo)) {
      history.push(dashboardHelper.getRouteForService(redirectTo ?? ''));
    }
  }, [isLoading]);

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <section className={styles['switcher-container']}>
      <h1>{t('common.welcome')}</h1>
      <p>{t('selectADashboard')}</p>
      <div className={styles['card-container']}>
        {_map(services, (enabled, serviceName) => {
          if (!enabled || serviceName === 'community' || serviceName === 'classroom_mentorship') {
            return null;
          }
          return <MentorTypeCard key={serviceName} type={serviceName} />;
        })}
      </div>
    </section>
  );
};
